/**
 * Update meta tags in document head
 */
export const updateMetaTags = (title, description, ogImage = '', canonicalUrl = '') => {
  // Set or update title
  if (document.title !== title) {
    document.title = title;
  }

  // Update or create meta description
  let metaDescription = document.querySelector('meta[name="description"]');
  if (!metaDescription) {
    metaDescription = document.createElement('meta');
    metaDescription.name = 'description';
    document.head.appendChild(metaDescription);
  }
  metaDescription.content = description;

  // Update or create Open Graph title
  let ogTitle = document.querySelector('meta[property="og:title"]');
  if (!ogTitle) {
    ogTitle = document.createElement('meta');
    ogTitle.setAttribute('property', 'og:title');
    document.head.appendChild(ogTitle);
  }
  ogTitle.content = title;

  // Update or create Open Graph description
  let ogDescription = document.querySelector('meta[property="og:description"]');
  if (!ogDescription) {
    ogDescription = document.createElement('meta');
    ogDescription.setAttribute('property', 'og:description');
    document.head.appendChild(ogDescription);
  }
  ogDescription.content = description;

  // Update or create Open Graph image
  if (ogImage) {
    let ogImageMeta = document.querySelector('meta[property="og:image"]');
    if (!ogImageMeta) {
      ogImageMeta = document.createElement('meta');
      ogImageMeta.setAttribute('property', 'og:image');
      document.head.appendChild(ogImageMeta);
    }
    ogImageMeta.content = ogImage;
  }

  // Update or create canonical tag
  if (canonicalUrl) {
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = canonicalUrl;
  }
};

/**
 * Generate Organization schema.org JSON-LD
 */
export const generateOrgSchema = () => {
  return {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: 'Skyewire Solutions',
    description: 'AI automation and security consulting for service and trade businesses',
    url: 'https://skyewire-solutions.com',
    email: 'spencermccain19@gmail.com',
    founder: {
      '@type': 'Person',
      name: 'Spencer McCain',
    },
    areaServed: 'US',
    serviceType: ['AI Automation Consulting', 'Security Infrastructure', 'Workflow Integration'],
  };
};

/**
 * Generate page-specific schema based on type
 */
export const generatePageSchema = (pageType, pageData = {}) => {
  const baseUrl = 'https://skyewire-solutions.com';

  const schemas = {
    home: {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: 'Skyewire Solutions - AI Automation & Security for Service Businesses',
      url: `${baseUrl}/`,
      description: 'Enterprise-grade automation and security built for growing service and trade businesses.',
    },
    solutions: {
      '@context': 'https://schema.org',
      '@type': 'CollectionPage',
      name: 'Our Solutions',
      url: `${baseUrl}/solutions`,
      description: 'From free assessment to ongoing partnership. Four-tier service model.',
      mainEntity: {
        '@type': 'ItemList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: 'AI Automation & Security Assessment',
            description: 'Free personalized report identifying automation opportunities.',
          },
          {
            '@type': 'ListItem',
            position: 2,
            name: 'Strategy & Consulting Call',
            description: 'Define your automation roadmap with Spencer.',
          },
          {
            '@type': 'ListItem',
            position: 3,
            name: 'Done-For-You Build',
            description: 'Custom automation and security implementation.',
          },
          {
            '@type': 'ListItem',
            position: 4,
            name: 'Managed Automation & Security Retainer',
            description: 'Ongoing partnership and support.',
          },
        ],
      },
    },
    about: {
      '@context': 'https://schema.org',
      '@type': 'AboutPage',
      name: 'About Skyewire Solutions',
      url: `${baseUrl}/about`,
      description: 'Learn about Spencer McCain and the Skyewire Solutions mission.',
    },
    contact: {
      '@context': 'https://schema.org',
      '@type': 'ContactPage',
      name: 'Contact Skyewire Solutions',
      url: `${baseUrl}/contact`,
      description: 'Get your free AI Automation & Security Assessment.',
    },
    thankYou: {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: 'Assessment Submitted',
      url: `${baseUrl}/thank-you`,
      description: 'Your assessment has been submitted. Check your email for your personalized report.',
    },
  };

  return schemas[pageType] || schemas.home;
};

/**
 * Inject JSON-LD schema into document head
 */
export const injectSchema = (schema) => {
  // Remove existing schema script if present
  const existingScript = document.querySelector('script[type="application/ld+json"]');
  if (existingScript) {
    existingScript.remove();
  }

  // Create and inject new schema
  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.innerHTML = JSON.stringify(schema);
  document.head.appendChild(script);
};
